export namespace StorageKeys {
  export const SESSION_TOKEN = 'io.density.planner.token';
  export const DO_NOT_TRACK_OVERRIDE =
    'io.density.planner.do-not-track-override';
  export const ANALYTICS_DEBUG = 'io.density.planner.analytics-debug';
}
